import {
  GET_SECTOR_BIDDINGS,
  GET_SECTOR_BIDDINGS_ERROR,
  GET_SECTOR_BIDDINGS_KPIS,
  GET_SECTOR_BIDDINGS_KPIS_ERROR,
  GET_SECTOR_BIDDINGS_KPIS_SUCCESS,
  GET_SECTOR_BIDDINGS_SUCCESS
} from './SectorBiddingsSection.actions'

const sectorBiddingsSectionState = {
  csv: [],
  data: [],
  deserted: 0,
  error: null,
  lessToTwo: 0,
  loading: false,
  moreThanThree: 0,
  totalAmount: 0,
  totalBiddings: 0,
  totalOrders: 0,
  totalPercentage: 0
}

/**
 * The sector biddings section's reducer.
 */
const sectorBiddingsSectionReducer = (state = sectorBiddingsSectionState, { payload, type }) => {
  switch (type) {
    case GET_SECTOR_BIDDINGS:
    case GET_SECTOR_BIDDINGS_KPIS: {
      return { ...state, loading: true }
    }
    case GET_SECTOR_BIDDINGS_ERROR:
    case GET_SECTOR_BIDDINGS_KPIS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SECTOR_BIDDINGS_SUCCESS: {
      return {
        ...state,
        csv: payload.csv,
        data: payload.data,
        loading: false,
        totalAmount: payload.totalAmount,
        totalAmountUSD: payload.totalAmountUSD,
        totalBiddings: payload.totalBiddings,
        totalOrders: payload.totalOrders,
        totalPercentage: payload.totalPercentage
      }
    }
    case GET_SECTOR_BIDDINGS_KPIS_SUCCESS: {
      return {
        ...state,
        deserted: payload.deserted,
        lessToTwo: payload.lessToTwo,
        loading: false,
        moreThanThree: payload.moreThanThree
      }
    }
    default: {
      return state
    }
  }
}

export default sectorBiddingsSectionReducer
